import { TableFieldModel } from '@/model/TableList'

export const materialTableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialNo',
    fieldName: '物料编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialClass',
    fieldName: '物料类别'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialUnit',
    fieldName: '物料单位'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialBrand',
    fieldName: '品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialName',
    fieldName: '名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialCode',
    fieldName: '代码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialParameter',
    fieldName: '参数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialDevice',
    fieldName: '使用设备'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型'
  }
]

export const supplierTableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierName',
    fieldName: '供应商'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierMainBusiness',
    fieldName: '主营业务'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '费用',
    isMoney: true,
    textAlign: 'right'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierWebsite',
    fieldName: '企业网站'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierContactNumber',
    fieldName: '企业联系'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierMail',
    fieldName: '企业邮箱'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierAddress',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierAddressDetail',
    fieldName: '详细地址'
  },
  {
    componentType: 'el-textarea',
    componentName: '输入框',
    fieldKey: 'supplierMark',
    fieldName: '备注信息'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierTitleName',
    fieldName: '发票抬头'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierTaxId',
    fieldName: '税号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierRegisteredAddress',
    fieldName: '注册地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierBank',
    fieldName: '开户银行'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierAccount',
    fieldName: '银行账号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplierPhone',
    fieldName: '电话号码'
  }

]
